import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Component, Inject} from '@angular/core';
import {ConfirmDeletionDialogComponent} from '../../confirm-deletion-dialog/confirm-deletion-dialog.component';

export interface VehicleCategoryData {
  id: number;
  name: string;
  title: string;
  useDvir: boolean;
  maxStationaryTime: number;
  observationTypeGroups: number[];
}

@Component({
  selector: 'app-dialog-confirm-delete-vehicle-category',
  templateUrl: './dialog-confirm-delete-vehicle-category.html',
  imports: [
    ConfirmDeletionDialogComponent
  ]
})
export class DialogConfirmDeleteVehicleCategoryComponent {
  dialogBody: string = null;

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmDeleteVehicleCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VehicleCategoryData
  ) {
    this.populateDialogBody();
  }

  private populateDialogBody() {
    this.dialogBody = `
      <p>
        Are you sure you want to delete vehicle group <strong>${this.data.title}</strong>?
      </p>
    `;
  }
}

